import Icon from '@autobest-ui/icon';

export interface UseConfigOptions {
  assetCommonUiUrl: string;
  assetOfficialUrl: string;
  WWWServiceUrl: string;
  assetSupportWebP: boolean;
}

// 配置静态资源链接库
export default class UseConfig {
  static assetCommonUiUrl = '';

  static assetOfficialUrl = '';

  static WWWServiceUrl = '';

  static assetSupportWebP = false;

  static setConfig(options: UseConfigOptions) {
    UseConfig.assetCommonUiUrl = options.assetCommonUiUrl;
    UseConfig.assetOfficialUrl = options.assetOfficialUrl;
    UseConfig.WWWServiceUrl = options.WWWServiceUrl;
    UseConfig.assetSupportWebP = options.assetSupportWebP;

    // 设置icon链接
    Icon.setConfig({
      baseUrl: `${options.assetCommonUiUrl}/svg`
    });
  }
}
